import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";

import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import { GET_USER_REPORT } from "../../../queries/ddwAdminQrys/SysAdminReportQrys";
import UserReportTable from "./UserReportTable";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const UserReportPage = () => {
  const { loading, error, data } = useQuery(GET_USER_REPORT);
  if (!data || loading || error)
    return (
      <div className='page-container user-report-container'>
        <Row>
          <Col>
            <h1 className="main-section-title">User Report</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {!data || loading ? <SkeletonLoader width='100%' /> : ""}
            {error ? <ErrorHandler error={error} /> : ""}
          </Col>
        </Row>
      </div>
    );
  return (
    <div className='page-container user-report-container'>
      <Row>
        <Col>
          <h1 className="main-section-title">User Report</h1>
        </Col>
        <Col>
          <CSVLink
            id='ddw-primary-hollow'
            className='btn btn-outline-light m-3 download-csv-btn'
            style={{ float: "right" }}
            data={data.getAllUsersCsvReport}
            filename='waterlinkAllUsersReport.csv'
            target='_blank'
          >
            <FontAwesomeIcon className='font-icon' icon={faCloudDownloadAlt} aria-hidden='true' />
            {' '}Download CSV
          </CSVLink>
        </Col>
      </Row>
      <Row>
        <Col>
          <UserReportTable data={data.getAllUsersCsvReport} />
        </Col>
      </Row>
    </div>
  );
};

export default UserReportPage;
